import { InjectionToken } from '@angular/core';

import { DoodProductModel } from '@core/models/product.model';

/** Resource-like suggestions state consumed by the block template. */
export type SuggestionCardsSuggestionsState = {
  readonly hasValue: boolean;
  readonly value: DoodProductModel[] | undefined;
  readonly isLoading: boolean;
};

/** Runtime VM emitted by `SuggestionCardsBlock` data sources. */
export type SuggestionCardsBlockViewModel = {
  suggestions: SuggestionCardsSuggestionsState;
};

export const SUGGESTION_CARDS_BLOCK_LOADING_VM: SuggestionCardsBlockViewModel = {
  suggestions: {
    hasValue: false,
    value: undefined,
    isLoading: true,
  },
};

export interface SuggestionCardsBlockDataSource {
  readonly vm$: import('rxjs').Observable<SuggestionCardsBlockViewModel>;
}

export const SUGGESTION_CARDS_BLOCK_DATA_SOURCE =
  new InjectionToken<SuggestionCardsBlockDataSource>('SUGGESTION_CARDS_BLOCK_DATA_SOURCE');

/** Writable suggestions-set id bound from the block input in production. */
export const SUGGESTION_CARDS_BLOCK_SUGGESTIONS_SET = new InjectionToken<
  import('@angular/core').WritableSignal<string | undefined>
>('SUGGESTION_CARDS_BLOCK_SUGGESTIONS_SET');
